import React, { useState } from "react";

// ── Inline SVG placeholder rendered as a data URI ────────────
// This never fails to load (no external dependency, no 404)
export const placeholderImage =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 600 400'%3E%3Crect width='600' height='400' fill='%23f1f5f9'/%3E%3Crect x='220' y='140' width='160' height='120' rx='16' fill='%23e2e8f0'/%3E%3Ccircle cx='270' cy='185' r='18' fill='%23cbd5e1'/%3E%3Cpolygon points='220,260 280,205 320,235 360,195 380,260' fill='%23cbd5e1'/%3E%3Cline x1='220' y1='140' x2='380' y2='260' stroke='%23ef4444' stroke-width='4' stroke-linecap='round'/%3E%3Cline x1='380' y1='140' x2='220' y2='260' stroke='%23ef4444' stroke-width='4' stroke-linecap='round'/%3E%3Ctext x='300' y='320' text-anchor='middle' font-family='system-ui%2Csans-serif' font-size='15' fill='%2394a3b8' font-weight='600'%3EGambar tidak tersedia%3C%2Ftext%3E%3C%2Fsvg%3E";

// Small icon variant (used in table thumbnails)
export const imageIcon =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='8' fill='%23f1f5f9'/%3E%3Ccircle cx='24' cy='26' r='6' fill='%23cbd5e1'/%3E%3Cpolygon points='8,56 24,36 36,46 48,30 56,56' fill='%23cbd5e1'/%3E%3Cline x1='8' y1='8' x2='56' y2='56' stroke='%23ef4444' stroke-width='3' stroke-linecap='round'/%3E%3Cline x1='56' y1='8' x2='8' y2='56' stroke='%23ef4444' stroke-width='3' stroke-linecap='round'/%3E%3C%2Fsvg%3E";

// ── URL validator ────────────────────────────────────────────
export const isValidUrl = (url) => {
  if (!url || typeof url !== "string") return false;
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// ── ImgWithFallback component ────────────────────────────────
// Drop-in <img> replacement that auto-falls back on 404 / error
export const ImgWithFallback = ({
  src,
  alt = "",
  fallback,
  className = "",
  ...props
}) => {
  const [errored, setErrored] = useState(false);
  const resolvedFallback = fallback || placeholderImage;
  const resolvedSrc =
    errored || !isValidUrl(src) ? resolvedFallback : src;

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={className}
      onError={() => setErrored(true)}
      {...props}
    />
  );
};

export default ImgWithFallback;
